module.exports = __webpack_public_path__ + "img/img1.709a3016.jpg";